'use client';
import { jsx, Fragment } from '@emotion/react/jsx-runtime';
import { useProps } from '@s7/styles';
import { IDENT, defaultProps } from './Transition.contract.js';
import { useTransition } from './useTransition/useTransition.js';
import { expandTransition } from './transitions/expandTransition/expandTransition.js';

const Transition = (props)=>{
    const [{ keepMounted, transition, duration, exitDuration, mounted, children, timingFunction, onExit, onEntered, onEnter, onExited }] = useProps(IDENT, props, defaultProps);
    const { transitionDuration, transitionStatus, transitionTimingFunction } = useTransition({
        mounted,
        exitDuration,
        duration,
        timingFunction,
        onExit,
        onEntered,
        onEnter,
        onExited
    });
    if (transitionDuration === 0) {
        if (mounted) {
            return /*#__PURE__*/ jsx(Fragment, {
                children: children({})
            });
        }
        if (keepMounted) {
            return children({
                display: 'none'
            });
        }
        return null;
    }
    if (transitionStatus === 'exited') {
        if (keepMounted) {
            return children({
                display: 'none'
            });
        }
        return null;
    }
    return /*#__PURE__*/ jsx(Fragment, {
        children: children(expandTransition({
            transition,
            duration: transitionDuration,
            state: transitionStatus,
            timingFunction: transitionTimingFunction
        }))
    });
};
Transition.displayName = IDENT;
var Transition$1 = Transition;

export { Transition, Transition$1 as default };
//# sourceMappingURL=Transition.js.map
